<template>
  <!--/*缅怀英烈，守护有我*/-->
  <div class="recollection">
    <div class="contentnr">
      <div class="top">
        <div>
          <slot name="plate"></slot>
        </div>
      </div>
      <div class="content">
        <div class="content-package clearfix">
          <div class="content-package-left">
            <Echarts :dataAll="dataAll" @handleCemetery="handleCemetery" @mousewheelpm="mousewheelpm"
                     @realtimebox="realtimebox"></Echarts>
            <div class="Upload-pop-up" v-show="isUpload">
              <div class="Upload-name">
                <span>设施名称 <br>(必填)</span>
                <textarea v-model="dryingTitle"></textarea>
              </div>
              <div class="Upload-dz">
                <span>所在地址 <br> (选填)</span>
                <textarea v-model="dryingArea"></textarea>
              </div>
              <div class="Upload-js">
                <span>简要介绍 <br> (选填)</span>
                <textarea v-model="dryingSynopsis"></textarea>
              </div>
              <div class="Upload-tj">
                <span>设施照片 <br> (选填)</span>
                <div>
                  <p>上传说明：</p>
                  <p>1、只能上传jpg、gif、png格式的图片</p>
                  <p>2、图片大小不能超过2M</p>
                  <p>3、可上传1-3张图片</p>
                </div>
              </div>
              <div class="Upload-tp">
                <div>
                  <div class="imgwrapfx clearfix">
                    <img v-for="(item,index) in upimg" preview="index" v-model="dryingArea" class="img" align="center"
                         :src="item">
                  </div>
                  <div class="leftContain">
                    <img id="img" class="img" align="center" preview="3" style="float: left" ref="fximgtp"
                         src="@/assets/img/upload.png">
                    <input type="file" @change="uploadImg($event)" ref="fximg" style="opacity:0"/>
                  </div>
                </div>
              </div>
              <div class="Upload-btn">
                <div class="close" @click="handleClose()">关闭</div>
                <div class="Submit" @click="handleSubmit()">提交</div>
              </div>
            </div>
          </div>
          <div class="content-package-right">
            <div class="Lightup Lightup-show clearfix" v-show="!lytitle">
              点亮小星星查看陵园
            </div>
            <div class="Lightup clearfix" v-show="lytitle">
              <div class="Lightup-left">
                <h3  :title="lytitle">{{lytitle}} </h3>
                <div :class="lyimg?lyimg:''"></div>
                <p>已被点亮</p>
                <p>{{lynum}}</p>
              </div>
              <div class="Lightup-right">
                <img :src=lybjtp alt="" preview="7">
              </div>
            </div>
            <div class="sun">
              <p class="sun-title">晒一晒</p>
              <p class="sun-describe">你所知道或去过的抗战纪念设施</p>
              <p class="sun-button">
                <span @click="handleupUploadData">我来晒</span>
              </p>
            </div>
            <div class="details">
              <div class="details-wrap">
                <h3>晒一晒
                  <div style="width: 100%; height: 1px; background-color: #6f4326 "></div>
                </h3>
                <div class="details-wrap-gd roll" style="padding-top: 30px" @mouseenter="mousewheelpm(true)"
                     @mouseleave="mousewheelpm(false)">
                  <div style="width: 100%;" v-for="(item,index) in baskinthesun" :key="index">
                    <p>{{item.userSheng}}网友&nbsp;晒出他去过的抗战纪念设施</p>
                    <h3>{{item.dryingTitle}}</h3>
                    <p>
                      {{item.dryingSyn}}
                      <span @click="handleShowFullText(item)" style="color: brown; cursor: pointer"
                            v-show="(item.dryingSynopsis.length>30 && item.dryingSyn.length <= 30 )">[展开]</span>
                      <span @click="handleShowFullText(item)" style="color: brown; cursor: pointer"
                            v-show="(item.dryingSynopsis.length>30 && item.dryingSyn.length > 30)">[收起]</span>
                    </p>
                    <ul class="clearfix">
                      <li v-for="(item,ind) in (item.dryingImgs)" :key="ind">
                        <img :src="item" :preview="ind" alt="">
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="record">
              <ul class="record-liet list" ref="scrollgd" :class="{'animate-up': animateUp}">
                <li v-for="(item, index) in scrollgd" :key="index" v-html="item">
                  {{item}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Echarts from "@/components/echarts"
  import {uploadFile} from '@/utils/upload.js'
  import {getmhyldata, getquerysysdata, getaddsysdata, getlightupdata} from "@/api/recollection.js"

  export default {
    data() {
      return {
        opensq:false,
        areay: [
          {"name": "北京", "value": "110000000000"},
          {"name": "天津", "value": "120000000000"},
          {"name": "河北", "value": "130000000000"},
          {"name": "山西", "value": "140000000000"},
          {"name": "内蒙古", "value": "150000000000"},
          {"name": "辽宁", "value": "210000000000"},
          {"name": "吉林", "value": "220000000000"},
          {"name": "黑龙江", "value": "230000000000"},
          {"name": "上海", "value": "310000000000"},
          {"name": "江苏", "value": "320000000000"},
          {"name": "浙江", "value": "330000000000"},
          {"name": "安徽", "value": "340000000000"},
          {"name": "福建", "value": "350000000000"},
          {"name": "江西", "value": "360000000000"},
          {"name": "山东", "value": "370000000000"},
          {"name": "河南", "value": "410000000000"},
          {"name": "湖北", "value": "420000000000"},
          {"name": "湖南", "value": "430000000000"},
          {"name": "广东", "value": "440000000000"},
          {"name": "广西", "value": "450000000000"},
          {"name": "海南", "value": "460000000000"},
          {"name": "重庆", "value": "500000000000"},
          {"name": "四川", "value": "510000000000"},
          {"name": "贵州", "value": "520000000000"},
          {"name": "云南", "value": "530000000000"},
          {"name": "西藏", "value": "540000000000"},
          {"name": "陕西", "value": "610000000000"},
          {"name": "甘肃", "value": "620000000000"},
          {"name": "青海", "value": "630000000000"},
          {"name": "宁夏", "value": "640000000000"},
          {"name": "新疆", "value": "650000000000"},
        ],
        lytitle: '',
        lyimg: '',
        lynum: '',
        lybjtp: '',
        lytextdata: '',
        animateUp: false,
        html: '',
        scrollgd: [ ],
        baskinthesun: '',
        dataAll: '',
        dryingTitle: '',
        isUpload: false,
        dryingArea: '',
        dryingSynopsis: '',
        isUploadimg: false,
        dryingImgs: [],
        upimg: []
      }
    },
    mounted() {
      this._initdata();

      let dropbox = document.querySelector('.img');
      dropbox.addEventListener('dragenter', this.onDrag, false);
      dropbox.addEventListener('dragover', this.onDrag, false);
    },
    components: {
      Echarts
    },
    methods: {
      _initlydata() {
        let item = this.areay[Math.floor(Math.random() * (this.areay.length-1))];
        let linyuanArray=this.dataAll[item.value];
        if(!linyuanArray || linyuanArray.length<=0){
         return this._initlydata();
        }
        let lingyuanitem = linyuanArray[Math.floor(Math.random() * (linyuanArray.length-1))];
        if(!lingyuanitem || !lingyuanitem.mmshName){
         return this._initlydata();
        }
        let text = item.name +"网友 &nbsp;&nbsp; 刚刚为&nbsp;"+lingyuanitem.mmshName+"&nbsp;点亮小星星";
        return text
      },
      _initdata() {
        getmhyldata().then((res) => {
          if (res.code == 200) {
            this.dataAll = res.data
            for (let i=0;i<10;i++){
              this.scrollgd.push(this._initlydata())
            }
            this.timer = setInterval(this.handleScrollAnimate, 850);
          }

        }).catch(() => {

        })
        getquerysysdata().then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.baskinthesun = res.data;
              this.baskinthesun.forEach((item) => {
                if (item.dryingImgs) {
                  item.dryingImgs = item.dryingImgs.split(',')
                }
                item['dryingSyn'] = (item.dryingSynopsis).substring(0, 30)
              })
            }
            this.$previewRefresh()
          }
        }).catch(() => {

        })
      },
      onDrag: function (e) {
        e.stopPropagation();
        e.preventDefault();
      },
      uploadImg(e) {
        let imgfile = this.$refs.fximg;
        let reader = new FileReader();
        reader.readAsDataURL(imgfile.files[0]);
        /*document.querySelector('.imgName').innerText = "删除";*/
        uploadFile(e.target.files[0]).then(
          (req) => {
            if (this.upimg.length == 2) {
              this.$refs.fximgtp.src = 'http://pic.nongbb.cn/' + req
            }
            if (this.upimg.length == 3) {
              alert("不能多余3张")
              return
            }
            this.upimg.push('http://pic.nongbb.cn/' + req)
            this.$previewRefresh()
          }
          , err => {
            if (String == typeof   err)
              console.log(err);
          })
      },
      toCheck() {
        this.isUploadimg = false
      },
      handleupUploadData() {
        this.isUpload = true
      },
      handleClose() {
        this.isUpload = false
        this.$refs.fximgtp.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAABJCAYAAAADvGlqAAACZ0lEQVR4nO3aQW4SURzH8b8wAwRY2JbaIoF2Btxq7MJob+BROIIXsDeQm8gFTHRp6qIlDYWURIolDcWaiMSh+ZNoasLbgDOT9+P3SWbDMOkbvkDfPObBxfu370SkLoSi4WjQ8us3LAqi1zyqJ9b9RUDEqIAYFRCjAmJUQIwKiFEBMSogRgXEqIAYFRCjAmJUQIwKiFEBMSogRgXEqIAYFRCjAmJUQA7qiX3/OZEPHz/JYDCQIAjmj7muK7VqVQ6ePZV0Evf9DHlmk9+BnLXPpd/v/w2qptOpnJyeyvVoFOv4wgb7dv12dWXcp3GR8X8qIEYFxKiAGBUQowKy9jpVL1vCPN7m61gro+rCgl6Hjm5ujM8Zj8fGfZ+Pv0g+nzfuL5dKUi49loyTXHmscbAyqq4U6cLCsobD4Xwz6Xa7cvjqpXiVipWfWCu/Y3TpL2xf+5dxn+bSrIx6f+kvLLPZLK7TWxlnv4CsjOo44U8Fkkk7J0lia1TP80L/GzXfs/ayxsrZ74uD5/MX/fb2h/E5J62WcYbr+76UikXjsY8KBclk0v9lrHGwMqp+gopbmyK6LaALC+1Ox3i8v78nld2dyMYbNU6UADEqIEYFxKiAGBUQbNRUKmXcN5n8inQsUYONul0oLHw8m83K5sbDyMcTJcibufU69onvies6//zakkgk5osW+Vwu1vGFDfYOff2BW38P1e0+5Dvz/4CNKmsScBHOfgExKiBGBcSogBgVEKMCYlRAjAqIUQExKiBGBcSogBgVEKMCYlRAjAqIUQExKiBGBcSogBgVkN5N2Og1j+rr/kLAEGncAQVQeSDsEQIdAAAAAElFTkSuQmCC"
        this.handleReset()
      },
      handleReset() {
        this.dryingTitle = '',
        this.dryingArea = '',
        this.dryingSynopsis = ''
        this.upimg = []
      },
      handleSubmit() {
        let data = {
          dryingTitle: this.dryingTitle,
          dryingArea: this.dryingArea,
          dryingSynopsis: this.dryingSynopsis,
          dryingImgs: this.upimg.toString()
        }
        let reg = /^[\u4E00-\u9FA5]+(·[\u4E00-\u9FA5]+)*$/;
        if (reg.test(this.dryingTitle)) {
          getaddsysdata(data).then((res) => {
            if (res.code == 200) {
              this.isUpload = false;
              this.handleReset()
            }
          }).catch((err) => {
            alert('失败')
          })
        } else {
          alert("标题中文且必填")
        }
      },
      handleScrollAnimate() {
        this.animateUp = true;
        setTimeout(() => {
          this.scrollgd.push(this._initlydata());
          this.scrollgd.shift();
          this.animateUp = false
        }, 600)
      },
      handleCemetery(data) {
          this.lytitle = data.mmshName,
          this.lyimg = true,
          this.lynum = (data.mmshLikeNum + 1) + "次",
          this.lybjtp = data.mmshPicDamen
        this.$previewRefresh()
      },
      mousewheelpm(data) {
        this.$emit('mousewheelmr', data)
      },
      realtimebox(data) {
        this.html = '<p style="color: red">' + data + '</p>'
       if(this.scrollgd.length>4){
         this.scrollgd[6]=this.html
       }
      },
      handleShowFullText(item) {
        debugger
        if(item.dryingSyn.length<=30){
          item.dryingSyn =  item.dryingSynopsis
        }else {
          item.dryingSyn =  (item.dryingSynopsis).substring(0, 30)
        }
      },
    },
    destroyed() {
      clearInterval(this.timer)
    }
  }
</script>
<style scoped>
  .Lightup-show {
    font-size: 30px;
    font-weight: 700;
    line-height: 183px;
    background-image: linear-gradient(90deg,
    #c80000 0%,
    #ff0000 52%,
    #c80000 100%),
    linear-gradient(
      #aa0000,
      #aa0000);
    background-blend-mode: normal,
    normal;
    border-radius: 0.020833rem;
    text-align: center;
    color: white;
  }

  .imgName, .imgbtn {
    color: #ffffff;
    background-color: #6f4326;
    padding: 2px 3px;
    border-radius: 4px;
  }

  .Upload-pop-up {
    position: absolute;
    top: 108px;
    right: 10px;
    width: 352px;
    height: 512px;
    background-color: #ffe6c4;
    box-shadow: 3px 4px 14px 1px rgba(159, 97, 0, 0.5);
    border-radius: 8px;
    border: solid 1px #c2894c;
    padding: 22px 22px 0px 10px;
    box-sizing: border-box;
  }

  .Upload-name {
    display: flex;
  }

  .Upload-pop-up > div:nth-child(1) {
    margin-top: 0px !important;
  }

  .Upload-pop-up > div {
    display: flex;
    margin-top: 15px;
  }

  .Upload-pop-up > div > span {
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
    width: 90px;
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 1px;
    color: #000000;
  }

  .Upload-pop-up > div > textarea {
    flex: 1;
    border: solid 1px #e2b686;
  }

  .Upload-dz {

  }

  .Upload-js {

  }

  .Upload-js > textarea {
    width: 250px;
    height: 104px;
    border: solid 1px #e2b686;
  }

  .Upload-tj > div {
    text-align: left;
    width: 250px;
    padding-left: 5px;
    box-sizing: border-box;
    font-size: 10px;
  }

  .Upload-tj > div > p {
    line-height: 18px;
  }

  .Upload-tp {
    display: flex;
    justify-content: space-between;
  }

  .Upload-tp > div {
    display: flex;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .Upload-btn {
    display: flex;
    justify-content: space-around;
    margin-top: 40px !important;
  }

  .Upload-btn > div {
    width: 110px;
    height: 34px;
    border-radius: 4px;
    color: white;
    font-size: 16px;
    line-height: 34px;
    cursor: pointer;
  }

  .Upload-btn > div:hover {
    background-color: #40a9ff !important;
  }

  .Submit {
    background-image: linear-gradient(0deg,
    #9b0000 0%,
    #b20000 26%,
    #e40000 70%,
    #ff0000 95%),
    linear-gradient(
      #aa0000,
      #aa0000);
  }

  .close {
    background-image: linear-gradient(0deg,
    #7d5524 0%,
    #daab72 100%),
    linear-gradient(
      #aa0000,
      #aa0000);
  }

  .recollection {
    height: 100%;
    text-align: center;
  }

  .content {
    width: 100%;
    height: 100%;
  }

  .contentnr {
    width: 100%;
    float: left;
  }

  .top {
    position: relative;
    width: 100%;
    height: 226px;
  }

  .top > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1382px;
    height: 193px;
    background: url("../../../assets/img/tophongqi.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }

  .content {
    width: 100%;
    padding-top: 10px;
    text-align: center;
  }

  .content-package {
    display: inline-block;
    width: 1382px;
    height: 678px;
  }

  .content-package-left {
    position: relative;
    width: 950px;
    height: 677px;
    float: left;
    background-color: #e5cb9e;
  }

  .content-package-right {
    float: right;
    width: 419px;
    height: 677px;
  }

  .content-package-right > .Lightup {
    width: 100%;
    height: 183px;
    border: solid 1px #bb8d46;
    margin-bottom: 9px;
  }

  .content-package-right > .sun {
    width: 100%;
    height: 129px;
    background-image: linear-gradient(90deg,
    #e3b57d 0%,
    #ffdfb8 50%,
    #e3b57d 100%),
    linear-gradient(
      #6f4326,
      #6f4326);
    background-blend-mode: normal,
    normal;
    border-radius: 8px;
    margin-bottom: 9px;
  }

  .content-package-right > .details {
    width: 100%;
    height: 213px;
    border: solid 1px #bb8d46;
    margin-bottom: 10px;
    text-align: left;
    padding: 10px 5px 10px 25px;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 4px;
  }

  .content-package-right > .record {
    width: 100%;
    height: 119px;
    background-image: linear-gradient(
      #f9e9d3,
      #f9e9d3),
    linear-gradient(
      #6f4326,
      #6f4326);
    background-blend-mode: normal,
    normal;
    border-radius: 8px;
    border: solid 1px #bb8d46;
    overflow: hidden;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }

  .Lightup-left {
    float: left;
    width: 161.6px;
    height: 100%;
    text-align: center;
  }

  .Lightup-left > div {
    animation: breath 1300ms ease-in-out infinite;
  }

  .Lightup-left > h3 {
    font-size: 18px;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    margin-top: 20px;
    font-weight: 600;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .Lightup-left > p {
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: #990000;
    font-weight: 600;
  }

  .Lightup-left > div {
    display: inline-block;
    width: 39.5px;
    height: 37px;
    background: url("../../../assets/img/wjx.png") no-repeat;
    background-size: 100% 100%;
  }

  .Lightup-right {
    width: 250.5px;
    float: left;
    height: 100%;
  }

  .Lightup-right > img {
    width: 248px;
    height: 165px;
    background-color: #6f4326;
    margin-top: 9px;
  }

  .sun-title {
    font-size: 34px;
    color: #990000;
    text-align: center;
    font-weight: 900;
  }

  .sun-describe {
    text-align: center;
    font-size: 21.5px;
    color: #990000;
    font-weight: 900;
    margin-top: 4px;
    margin-bottom: 7px;
  }

  .sun-button {
    text-align: center;
  }

  .sun-button > span {
    display: inline-block;
    width: 121.2px;
    height: 36px;
    font-weight: 900;
    background-image: linear-gradient(90deg,
    #c80000 0%,
    #ff0000 52%,
    #c80000 100%),
    linear-gradient(
      #aa0000,
      #aa0000);
    background-blend-mode: normal,
    normal;
    border-radius: 4px;
    text-align: center;
    color: white;
    font-size: 22px;
    line-height: 36px;
    cursor: pointer;
  }

  .leftContain {
    width: 103px;
    height: 64px;
    display: inline-block;
    float: left;
    position: relative;
  }

  .leftContain img {
    width: 103px;
    height: 64px;
    position: relative;
    z-index: 10000;
  }

  .leftContain input { /*与#leftContain img一样*/
    width: 103px;
    height: 64px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10000;
    cursor: pointer;
  }

  .Upload-img {
    width: 100%;
    height: 100%;
    position: absolute;

  }

  .details {

  }

  .details-wrap {
    width: 100%;
    height: 100%;
    padding-right: 10px;

  }

  .details-wrap > h3 {
    position: fixed;
    width: 340px;
    background: url("../../../assets/img/bj.png");
    font-size: 22px !important;
  }

  .details-wrap h3 {
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    line-height: 30px;
    color: #990000;
    font-weight: bold;
  }

  .details-wrap-gd {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 0px 40px 0px 0px;
    box-sizing: border-box;
  }

  .details-wrap-gd > div {
    margin-bottom: 10px;
    border-bottom: dashed 1px darkgray;
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .details-wrap-gd h3 {
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    line-height: 30px;
    color: #990000;
    font-weight: bold;
  }

  .details-wrap-gd p {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    line-height: 24px;
    color: #000000;
  }

  .details-wrap-gd ul {
    display: flex;
    justify-content: space-between;

  }

  .details-wrap-gd ul li {
    float: left;
    width: 107.7px;
    height: 72px;
  }

  .details-wrap-gd ul li img {
    width: 100%;
    height: 100%;
  }

  .record-liet {
    position: absolute;
    top: -4px;
    width: 100%;
  }

  .record-liet > li {
    width: 100%;
    padding-right: 10px;
    box-sizing: border-box;
    text-align: left;
    line-height: 28px;
    font-size: 15px;
    color: #000000;
  }

  .animate-up {
    transition: all 0.8s ease-in-out;
    transform: translateY(-35px);
  }

  .record-liet > li {
    transition: all 0.5s ease-in-out;
  }

  .record-liet li:nth-child(1) {
    opacity: 0.3;
  }

  .record-liet li:nth-child(2) {
    opacity: 0.5;
  }

  .record-liet li:nth-child(3) {
    opacity: 0.7;
  }

  .imgwrapfx {
    float: left;
    width: 210px;
    height: 64px;
    overflow: hidden;
  }

  .imgwrapfx > img {
    float: left;
    width: 103px;
    height: 64px;
  }

  .color-text {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/recollection.vue